import { paramBuilder } from "../builders/param.builder";
import { RestClient } from "../client/rest.client";
//import { RequestParamConstants } from "../../../constants/request-param.constants";
/* tslint:disable */

export const PATH: string = "Path";
export const QUERY: string = "Query";
export const REQUEST_BODY: string = "RequestBody";
export const PLAIN_BODY: string = "PlainBody";
export const HEADER: string = "Header";

export const Path = paramBuilder(PATH);
export const Query = paramBuilder(QUERY);
export const RequestBody = paramBuilder(REQUEST_BODY)(REQUEST_BODY);
export const PlainBody = paramBuilder(PLAIN_BODY)(PLAIN_BODY);
export const Header = paramBuilder(HEADER);
